import React from 'react';
import { LinkedinIcon, MailIcon } from 'lucide-react';
export function Footer() {
  const navLinks = [{
    name: 'My Story',
    href: '/my-story'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'Results',
    href: '/results'
  }, {
    name: 'Resources',
    href: '/resources'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  return <footer className="w-full bg-brand-light-gray py-12 px-4 sm:px-6 lg:px-8" data-id="element-78" data-mp="3ugbqj7nstejc">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0" data-id="element-79" data-mp="38zaivynj750">
        <div className="text-brand-gray-light text-sm" data-id="element-80" data-mp="3ldkgncakmqtt">
          © 2026 Break a Pencil Consulting
        </div>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-81" data-mp="3qblwzpgm4c1l">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-gray-light hover:text-brand-orange transition-colors text-sm font-medium" data-id="element-82" data-mp="2a19vns22jyzx">
              {link.name}
            </a>)}
        </div>

        <div className="flex items-center space-x-4" data-id="element-83" data-mp="3gbqz6ionarch">
          <a href="mailto:michael@breakapencil.com" className="text-brand-gray-light hover:text-brand-orange transition-colors" aria-label="Email Michael" data-id="element-84" data-mp="3v7gejxzbs688">
            <MailIcon className="w-5 h-5" data-id="element-85" data-mp="82qu9y9z03wd" />
          </a>
          <a href="https://www.linkedin.com/in/mhirsch/" target="_blank" rel="noopener noreferrer" className="text-brand-gray-light hover:text-brand-orange transition-colors" aria-label="LinkedIn Profile" data-id="element-86" data-mp="817cg38o1ksh">
            <LinkedinIcon className="w-5 h-5" data-id="element-87" data-mp="cv1smwp2bhmt" />
          </a>
        </div>
      </div>
    </footer>;
}